<template lang="html">
  <b-field>
    <template slot="label">
      Progress
      <b-tooltip
        position="is-right"
        type="is-dark"
        multilined
        size="is-small"
        label="Progress that indicates to students how far you are in the procedure"
      >
        <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>

    <b-slider
      class="pb-4 px-5"
      v-bind:type="localProgress === 2 ? 'is-success' : 'is-primary'"
      :min="0"
      :max="2"
      :tooltip="false"
      v-model="localProgress"
      @input="updateProgress"
    >
      <b-slider-tick :value="0">Draft</b-slider-tick>
      <b-slider-tick :value="1">Work in progress</b-slider-tick>
      <b-slider-tick :value="2">Completed</b-slider-tick>
    </b-slider>
  </b-field>
</template>

<script>
export default {
  props: ['progress', 'itemType'],
  data () {
    return {
      localProgress: 0
    }
  },
  created () {
    this.localProgress = this.progress
  },
  methods: {
    updateProgress (value) {
      this.$emit('updateProgress', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
